var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.refractive
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page refractive-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_refractive" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "18px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.refractive.hospitalName
                      ? _vm.model.refractive.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "22px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.refractive.reportName
                        ? _vm.model.refractive.reportName
                        : "屈光筛查报告"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "margin-left": "15px",
                  "margin-right": "8px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.schoolName
                                  ? _vm.model.refractive.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.gradeName
                                  ? _vm.model.refractive.gradeName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.className
                                  ? _vm.model.refractive.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("编号："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.barCode
                                  ? _vm.model.refractive.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("筛查时间："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.screeningTime
                                  ? _vm.model.refractive.screeningTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.name
                                  ? _vm.model.refractive.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.sex
                                  ? _vm.model.refractive.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.age
                                  ? _vm.model.refractive.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c("div", {
              staticStyle: { "border-bottom": "1px solid rgb(14, 14, 14)" },
            }),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-top": "10px",
                  "margin-left": "15px",
                  "padding-top": "20px",
                  "padding-bottom": "20px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _vm._m(0),
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "25px", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            color: "rgb(66, 100, 216)",
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [_vm._v("右眼")]
                      ),
                      _vm._m(1),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.rightEyeSBallDiameter
                                  ? _vm.model.refractive.rightEyeSBallDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.sballNormalRange
                                  ? _vm.model.refractive.sballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                            "border-right": "2px solid rgb(0, 0, 0)",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive
                                  .rightEyeSBallDiameterIndication
                                  ? _vm.model.refractive
                                      .rightEyeSBallDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "25px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            color: "rgb(66, 100, 216)",
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [_vm._v("左眼")]
                      ),
                      _vm._m(2),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.leftEyeSBallDiameter
                                  ? _vm.model.refractive.leftEyeSBallDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.sballNormalRange
                                  ? _vm.model.refractive.sballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive
                                  .leftEyeSBallDiameterIndication
                                  ? _vm.model.refractive
                                      .leftEyeSBallDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "25px", border: "none" } },
                    [
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _vm._m(3),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.rightEyeCColumnDiameter
                                  ? _vm.model.refractive.rightEyeCColumnDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.cballNormalRange
                                  ? _vm.model.refractive.cballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                            "border-right": "2px solid rgb(0, 0, 0)",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive
                                  .rightEyeCColumnDiameterIndication
                                  ? _vm.model.rightEyeCColumnDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "25px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _vm._m(4),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.leftEyeCColumnDiameter
                                  ? _vm.model.refractive.leftEyeCColumnDiameter
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.cballNormalRange
                                  ? _vm.model.refractive.cballNormalRange
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive
                                  .leftEyeCColumnDiameterIndication
                                  ? _vm.model.refractive
                                      .leftEyeCColumnDiameterIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "25px", border: "none" } },
                    [
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _vm._m(5),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.rightEyeTrustTimes
                                  ? _vm.model.refractive.rightEyeTrustTimes
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                            "border-right": "2px solid rgb(0, 0, 0)",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive
                                  .rightEyeTrustTimesIndication
                                  ? _vm.model.refractive
                                      .rightEyeTrustTimesIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "25px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _vm._m(6),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.leftEyeTrustTimes
                                  ? _vm.model.refractive.leftEyeTrustTimes
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.refractive.leftEyeTrustTimesIndication
                                  ? _vm.model.refractive
                                      .leftEyeTrustTimesIndication
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c("div", {
              staticStyle: {
                "text-align": "left",
                "margin-top": "10px",
                "padding-top": "10px",
                "padding-left": "15px",
                "padding-bottom": "10px",
                "border-bottom": "1px solid rgb(14, 14, 14)",
              },
            }),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  "margin-left": "15px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(7),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.refractive.screeningSummary
                                    ? _vm.model.refractive.screeningSummary
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(8),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.refractive.recommendations
                                    ? _vm.model.refractive.recommendations
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "refractive_childrenVisionCareTips",
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(9),
                          _vm._l(
                            _vm.model.refractive.childrenVisionCareTips,
                            function (item, index) {
                              return _c(
                                "div",
                                { staticStyle: { "min-height": "20px" } },
                                [_c("p", [_vm._v(_vm._s(item ? item : ""))])]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      { staticStyle: { "line-height": "25px", border: "none" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("眼睛")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("指标")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("检查结果")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("范围")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
              "border-right": "2px solid rgb(0, 0, 0)",
            },
          },
          [_vm._v("指示")]
        ),
        _c("td", {
          staticStyle: {
            width: "25px",
            "border-collapse": "collapse",
            border: "none",
          },
        }),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("眼睛")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("指标")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("检查结果")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("范围")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("指示")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("s球径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("s球径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("c柱径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("c柱径"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("轴位"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _vm._v("轴位"),
        _c("span", { staticStyle: { color: "rgb(255, 83, 86)" } }, [
          _vm._v("*"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【初筛结果】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【建议】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【儿童视力保健提示】"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }